import { hygraphClient } from '@/lib/graphql-clients';
import { getSdk, Page } from '@/lib/types';

import { Discipline } from '@/services/disciplines.service';
import { buildJobCanonicalLinkFromDiscipline } from '@/utils/canonical-link-utils';

type GetProps = {
  preview?: boolean;
};

const get = async (props?: GetProps) => {
  const sdk = getSdk(hygraphClient(props?.preview || false));
  const { jobCategoryPages } = await sdk.JobCategoryPages();
  return jobCategoryPages;
};

const getByPage = async (page: Page, disciplines: Discipline[]) => {
  const pageRoutes: Record<string, string> = {};

  if (!disciplines.length) {
    return pageRoutes;
  }

  let hasHeroWithSearch = false;
  page?.hero?.section?.rows.forEach((row) => {
    if (row.__typename === 'HeroWithSearch') {
      hasHeroWithSearch = true;
    }
  });

  if (!hasHeroWithSearch) {
    return pageRoutes;
  }

  disciplines.forEach((discipline) => {
    pageRoutes[discipline.slug] =
      buildJobCanonicalLinkFromDiscipline(discipline);
    return;
  });

  return pageRoutes;
};

const JobCategoryPageRoutesService = {
  get,
  getByPage,
};

export default JobCategoryPageRoutesService;
